<template>
  <div class="listing-popover listing-popover--housing" @mousedown.stop>
    <div v-if="housingTypes.length" class="listing-popover__section">
      <p class="listing-popover__label">{{ t('listing-search.housing.kind') }}</p>
      <TypeSelect
        :housing-types="housingTypes"
        :model-value="criteria.types"
        @update:model-value="update({ types: $event })"
      />
    </div>

    <div class="listing-popover__section">
      <p class="listing-popover__label">{{ t('listing-search.housing.rooms') }}</p>
      <div class="listing-pills">
        <button
          v-for="bed in BEDROOM_OPTIONS"
          :key="bed"
          type="button"
          class="listing-pill listing-pill--block"
          :class="{ 'is-on': criteria.beds.includes(bed) }"
          @click="toggleBed(bed)"
        >
          {{ bed === BEDROOM_PLUS_FROM ? `${bed}+` : bed }}
        </button>
      </div>
    </div>

    <div class="listing-popover__section">
      <p class="listing-popover__label">{{ t('listing-search.housing.living-area') }}</p>
      <RangeSlider
        :min="bounds.m2.min"
        :max="bounds.m2.max"
        :step="5"
        unit=" m²"
        :label="t('listing-search.housing.living-area-aria')"
        :model-value="[criteria.m2?.[0] ?? bounds.m2.min, criteria.m2?.[1] ?? bounds.m2.max]"
        @update:model-value="update({ m2: $event })"
      />
    </div>

    <div class="listing-popover__section">
      <p class="listing-popover__label">{{ t('listing-search.housing.parcel-area') }}</p>
      <RangeSlider
        :min="bounds.perceel.min"
        :max="bounds.perceel.max"
        :step="25"
        unit=" m²"
        :label="t('listing-search.housing.parcel-area')"
        :model-value="[criteria.perceel?.[0] ?? bounds.perceel.min, criteria.perceel?.[1] ?? bounds.perceel.max]"
        @update:model-value="update({ perceel: $event })"
      />
    </div>

    <div class="listing-popover__footer">
      <button type="button" class="listing-link-button" @click="clear">{{ t('listing-search.clear') }}</button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import RangeSlider from './RangeSlider.vue';
import TypeSelect from './TypeSelect.vue';
import { useCriteria } from '../lib/useCriteria';
import { BEDROOM_OPTIONS, BEDROOM_PLUS_FROM } from '../lib/criteriaContract';
import { t } from '../lib/i18n';

const props = defineProps({
  bootstrap: { type: Object, required: true }
});

const { criteria, update } = useCriteria();

const bounds = computed(() => props.bootstrap.bounds);
const housingTypes = computed(() => props.bootstrap.housingTypes);

const toggleBed = (bed) => {
  const beds = criteria.beds.includes(bed)
    ? criteria.beds.filter((item) => item !== bed)
    : [...criteria.beds, bed];
  update({ beds });
};

const clear = () => update({ m2: null, perceel: null, beds: [], types: [] });
</script>
